<template>
  <component
    :is="`step-${step}`"
    :step="step"
    :box_init="box"
    :box.sync="current_value"
    v-on="$listeners"
    @change-step="mixin_set_step"
  />
</template>

<script>
  import StepInit from './steps/init';
  import StepCreateNumber from './steps/create-number';
  import { BaseMixin } from '../_base/_base-mixin';

  /**
   * Из схемы передается параметр box - текущее состояние бокса и его параметров на схеме
   * При переходе по шагам мы должны сохранять введенные значения,
   * но не обновлять инфу на схеме до нажатия кнопки "сохранить" на шаге Init.
   * По этому box копируется в current_value в BaseMixin.
   * .sync - аналог v-model только для кастомных названий
   */

  export default {
    components: {
      StepInit,
      StepCreateNumber
    },

    mixins: [BaseMixin]
  };
</script>
